import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
// 自己ホスト variable font (Inter = Latin/数字, Noto Sans JP = 日本語)。
// Mgr 承認のうえ @fontsource-variable を使用。外部 CDN / Google Fonts は使わず、
// font-display: swap + unicode-range subset で deterministic かつ軽量に描画する。
import '@fontsource-variable/inter';
import '@fontsource-variable/noto-sans-jp';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// ErrorBoundary を BrowserRouter の外側に置くことで、router 内で発生した
// render 例外だけでなく App 初期化時の例外もカバーする (#255)。
// Admin / Portal 両方に適用される。
createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
